import React from 'react';
import Proptypes from 'prop-types';
import AccountPickerLauncher from './AccountPickerLauncher';
import AccountPickerSelectedAccount from './AccountPickerSelectedAccount';
import { LARGE_CUSTOMER_MIN_ACCOUNTS_SIZE } from '../../constants/LargeCustomerViewConstants';

const DetermineAccountPicker = ({
  numberOfAccounts,
  isLargeCustomerView,
  selectedAccount,
  onChooseAccount,
  renderDropDown,
  chooseAccountText,
  content,
}) => {
  if (isLargeCustomerView && !selectedAccount) {
    return (
      <AccountPickerLauncher
        onShowAccountPicker={onChooseAccount}
        mainLabelText={content.accountPickerTitle}
        bodyText={chooseAccountText}
        buttonText={content.accountPickerLauncherButton}
      />
    );
  } else if (isLargeCustomerView && selectedAccount) {
    return (
      <AccountPickerSelectedAccount
        onShowAccountPicker={onChooseAccount}
        account={selectedAccount}
        mainLabelText={content.accountPickerTitle}
        buttonText={content.accountPickerSelectedButton}
      />
    );
  } else if (
    numberOfAccounts > 1 &&
    numberOfAccounts < LARGE_CUSTOMER_MIN_ACCOUNTS_SIZE
  ) {
    return renderDropDown();
  }
  return null;
};

DetermineAccountPicker.propTypes = {
  numberOfAccounts: Proptypes.number.isRequired,
  isLargeCustomerView: Proptypes.bool.isRequired,
  selectedAccount: Proptypes.object,
  onChooseAccount: Proptypes.func.isRequired,
  renderDropDown: Proptypes.func.isRequired,
  content: Proptypes.shape({
    accountPickerLauncherButton: Proptypes.string.isRequired,
    accountPickerSelectedButton: Proptypes.string.isRequired,
  }),
  chooseAccountText: Proptypes.string.isRequired,
};

export default DetermineAccountPicker;
